/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Why_CancelingInputs */

const en_dialog_why_canceling = /** @type {(inputs: Dialog_Why_CancelingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are you canceling?`)
};

const es_dialog_why_canceling = /** @type {(inputs: Dialog_Why_CancelingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué estás cancelando?`)
};

/**
* | output |
* | --- |
* | "Why are you canceling?" |
*
* @param {Dialog_Why_CancelingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_why_canceling = /** @type {((inputs?: Dialog_Why_CancelingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Why_CancelingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_why_canceling(inputs)
	return en_dialog_why_canceling(inputs)
});